"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ticks1, ticks2) {
    return ticks1.length === ticks2.length && (ticks1.length === 0 || ticks1[ticks1.length - 1].epoch === ticks2[ticks2.length - 1].epoch);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/areTickArraysEqual.js
// module id = 113
// module chunks = 0